// Generated by CoffeeScript 2.7.0
var UserProfileSchema;

import BaseModel from '../base_model.js';

import Fieldable from '../concerns/fieldable.js';

export default UserProfileSchema = class UserProfileSchema extends BaseModel {
  constructor(attrs = {}) {
    super(attrs);
    this._makeFields(attrs.fields, {});
  }

  toJSON() {
    return _.extend(super.toJSON(), {
      fields_attributes: this._generateFieldAttributes()
    });
  }

};

UserProfileSchema.assemble(Fieldable);
